export const LEVELS_GET_ALL_REQUEST = 'LEVELS_GET_ALL_REQUEST';
export const LEVELS_GET_ALL_SUCCESS = 'LEVELS_GET_ALL_SUCCESS';
export const LEVELS_GET_ALL_ERROR = 'LEVELS_GET_ALL_ERROR';
